import { AppThunk } from '@/store'
import { createAction, request } from '@/store/actions'

import {
  ADD_CUSTOM_APP_INSTANCE,
  CLEAR_CURRENT_APP,
  DELETE_CUSTOM_APP_INSTANCE,
  FETCH_CUSTOM_APP_INSTANCE,
  SET_CURRENT_APP,
  SET_CURRENT_CONNECTOR,
  SET_CURRENT_MICROAPPS,
  UPDATE_CUSTOM_APP_INSTANCE
} from './actionTypes'

export const fetchCustomAppInstance = (appId: string): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/appinstances/${appId}`,
        FETCH_CUSTOM_APP_INSTANCE,
        { headers: { 'x-workgrid-space': ':spaceId' }, method: 'GET' },
        { args: { spaceId: ':spaceId' }, service: 'apps' }
      )
    )
  }
}

export const deleteCustomAppInstance = (appId: string): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/custom/appinstances/${appId}`,
        DELETE_CUSTOM_APP_INSTANCE,
        {
          headers: { 'x-workgrid-space': ':spaceId' },
          method: 'DELETE'
        },
        { args: { spaceId: ':spaceId' }, service: 'apps' }
      )
    )
  }
}

export const updateCustomAppInstance = (app: any): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        `/custom/appinstances/${app.id}`,
        UPDATE_CUSTOM_APP_INSTANCE,
        {
          body: { ...app },
          headers: { 'x-workgrid-space': ':spaceId' },
          method: 'PUT'
        },
        { args: { spaceId: ':spaceId' }, service: 'apps' }
      )
    )
  }
}

export const addCustomAppInstance = (appInstance: any): AppThunk => {
  return dispatch => {
    return dispatch(
      request(
        '/custom/appinstances',
        ADD_CUSTOM_APP_INSTANCE,
        {
          headers: { 'x-workgrid-space': ':spaceId' },
          method: 'POST',
          body: { ...appInstance }
        },
        { args: { spaceId: ':spaceId' }, service: 'apps' }
      )
    )
  }
}

export function clearCurrentApp(): AppThunk {
  return dispatch => {
    dispatch(createAction(CLEAR_CURRENT_APP))
  }
}

export function setCurrentApp(app: any): AppThunk {
  return dispatch => {
    dispatch(createAction(SET_CURRENT_APP, { app }))
  }
}

export function setCurrentConnector(connector: any): AppThunk {
  return dispatch => {
    dispatch(createAction(SET_CURRENT_CONNECTOR, { connector }))
  }
}

export function setCurrentMicroApps(microapps: any): AppThunk {
  return dispatch => {
    dispatch(createAction(SET_CURRENT_MICROAPPS, { microapps }))
  }
}
